<template>
	<div class="animated fadeIn">
		<MenuHeader :record_id="record_id" type="menus" :badge="orders.length">
			<div class="row">
				<div class="col-12">
					<OverviewCard name="orders">
						<div class="list--order" v-if="orders.length">
							<div class="col-sm-6 col-md-6 col-md-4" v-for="(order, i) in orders" :key="'order__' + i">
								<div class="jumbotron p-0 m-0">

									<div class="py-3 px-3">
										<dl class="row-dl m-0">
											<dt class="col-sm-9 pl-0">
												<span style>{{order.fullname}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="pull-right">{{$root.timeAgo(order.created_at)}}</div>
											</dd>
										</dl>

                                        <div class="scrollbar">
                                            <div class="list-group list-group-flush">
                                                <template v-for="(item, ii) in order.items">
                                                    <div
                                                    class="list-group-item pr-0 pl-0"
                                                    :key="ii"
                                                    style="background-color: transparent;"
                                                    >
                                                    <div class="d-flex w-100 justify-content-between align-items-center">
                                                        <b>{{$t('item title')}}</b>
                                                        <span>{{item.title}}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <b>{{$t('item_quantity')}}</b>
                                                        <span class="">{{item.quantity}}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <b>{{$t('item price')}}</b>
                                                        <span class="font-weight-bold text-danger">{{item.price}}</span>
                                                    </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

										<hr class="my-3" />

										<dl class="row-dl m-0">
											<dt class="col-sm-9 pl-0">
												<span style>{{$t('phone')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="pull-right">{{order.phone}}</div>
											</dd>
											<dt class="col-sm-9 pl-0">
												<span style>{{$t('address')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="pull-right">{{order.address}}</div>
											</dd>

											<dt class="col-sm-9 pl-0">
												<span style>{{$t('price')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="text-right">{{order.subtotal}}</div>
											</dd>

											<dt class="col-sm-9 pl-0">
												<span style>{{$t('tax')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="text-right">{{order.tax}}</div>
											</dd>

											<dt class="col-sm-9 pl-0">
												<span style>{{$t('shipping')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="text-right">{{order.shipping}}</div>
											</dd>

											<dt class="col-sm-9 pl-0">
												<span style>{{$t('total price')}}</span>
											</dt>
											<dd class="col-sm-3 pr-0">
												<div class="font-weight-bold text-right text-danger">{{order.price}}</div>
											</dd>
										</dl>

										<p v-if="order.notes">
											<em>{{order.notes}}</em>
										</p>
										<button
											class="btn btn-danger mb-0"
											@click="deleteOrder(i, order)"
											:disabled="!!order.hasRequest"
										>{{$t('delete')}}</button>
										<button
											class="btn btn-success mb-0"
											@click="confirmOrder(i, order)"
											:disabled="!!order.hasRequest"
										>{{$t('confirm')}}</button>
									</div>
								</div>
							</div>
						</div>
						<div class="list--order" v-else>
							<div class="list--order-center">
								<svg
									aria-hidden="true"
									focusable="false"
									data-prefix="fal"
									data-icon="bullhorn"
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 576 512"
								>
									<path
										fill="#e9ecef"
										d="M544 184.88V32c0-8.74-6.98-32-31.99-32H512c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64l-.48 32c0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h106.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.12c19.05-11.09 32-31.49 32-55.12.01-23.63-12.94-44.03-31.99-55.12zM223.76 480l-105.89-.03c-14.83-30.56-22.35-62.19-22.36-95.49l.48-32L96 352h99.33c-2.31 10.7-3.81 21.43-3.81 32 0 35.29 11.3 68.78 32.24 96zM64 320c-17.64 0-32-14.36-32-32v-96c0-17.64 14.36-32 32-32h192v160H64zm448.05 126.93c-.04.25-.13.58-.25.9l-84.83-67.87C386.99 348 338.54 328.14 288 322.13V157.87c50.54-6.01 98.99-25.87 138.98-57.84l84.87-67.9c.03.03.06.05.08.05.04 0 .06-.05.07-.17l.05 414.92z"
										class
									/>
								</svg>
							</div>
						</div>
					</OverviewCard>
				</div>
			</div>
		</MenuHeader>
	</div>
</template>
<script>
import axios from 'axios'

import {cSwitch, OverviewCard, MenuHeader} from '../../components'

export default {
	name: 'menu-order',
	components: {
		MenuHeader,
		OverviewCard,
	},
	mixins: [],
	data() {
		return {
			orders: [],
			timeleft: 5000,
			timeoutIndex: 0,
			countRequests: 0,
			record_id: 0,
		}
	},
	methods: {
		getOrdersEndpoint() {
			return `/shopping_cart/orders/${this.record_id}`
		},
		handleOnResponseOK(cb, res) {
			clearTimeout(this.timeoutIndex)

			if (res) {
				if (res.data.status) {
					cb(res.data.data || {})
				}
			}
			this.timeoutIndex = setTimeout(this.getOrders.bind(this), this.timeleft)
		},
		handleOnDataReceived(data) {
			if (data.hasOwnProperty(this.record_id)) {
				this.orders = data[this.record_id]
			} else {
				this.orders = []
			}
		},

		getOrders() {
			try {
				++this.countRequests
				axios
					.get(this.getOrdersEndpoint())
					.then(this.handleOnResponseOK.bind(this, this.handleOnDataReceived))
					.catch((e) => {
						console.warn(`Receiver error in: ${e}`)
					})
			} catch (e) {
				this.handleOnResponseOK()
				console.warn(`Receiver error ${e}`)
			}
		},
		confirmOrder(index, order) {
			if ((order = this.orders[index])) {
				axios.post(`/shopping_cart/orders/${order._id}/confirm`, {...order}).then((res) => {
					if (res.data.status === 1) {
						this.orders.splice(index, 1)
					}
				})
			}
		},
		deleteOrder(index, order) {
			if ((order = this.orders[index])) {
				axios.post(`/shopping_cart/orders/${order._id}/delete`).then((res) => {
					if (res.data.status === 1) {
						this.orders.splice(index, 1)
					}
				})
			}
		},
	},
	mounted() {
		this.record_id = parseInt(this.$route.params.id)
		this.record_id && this.getOrders()
	},
	destroyed() {
		clearTimeout(this.timeoutIndex)
	},
}
</script>
